import React, { Fragment } from 'react'
import { Header, SubHeader } from 'shared/components/ui/Typography'

import Form from './Form'

export default function AddTeamMembersPage() {
  return (
    <Fragment>
      <Header size="medium" as="h1">
        Let’s get the gang onboard
      </Header>
      <SubHeader size="small" as="h2">
        Add anybody from your team involved in customer conversations
      </SubHeader>
      <Form />
    </Fragment>
  )
}
